/**
 * Created by Administrador on 10/28/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('fares', {
                parent: 'app',
                url: '/fares?page&size',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    page: "0",
                    size: "100",
                    active: true
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/fare/fares.html',
                        controller: 'faresController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['fare', 'category']);
                    }],
                    fares: ['fareService', '$stateParams', function (fareService, $stateParams) {
                        return fareService.getFares($stateParams.page, $stateParams.size, true, $stateParams.active);
                    }]
                }
            })
            .state('fareNew', {
                parent: 'app',
                url: '/fare/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/fare/newEditFare.html',
                        controller: 'newEditFareController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['fare', 'category', 'passengerType','luggageRule']);
                    }],
                    loadForm: ['fareService', function(fareService) {
                        return fareService.loadForm();
                    }],
                    currencies: ['currencyService', function(currencyService){
                        return currencyService.getCurrencies()
                    }],
                    action: [function() {
                        return "new";
                    }]
                }
            })

            .state('fareEdit', {
                parent: 'app',
                url: '/fare/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configGeneral/rates/fare/editFare.html',
                        controller: 'newEditFareController',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['fare', 'category', 'passengerType','luggageRule']);
                            }],
                            loadForm: ['fareService', '$stateParams', function (fareService, $stateParams) {
                                return fareService.loadForm($stateParams.id)
                            }],
                            currencies: ['currencyService', function(currencyService){
                                return currencyService.getCurrencies()
                            }],
                            action: [function() {
                                return "edit";
                            }]
                        }
                    }
                }
            })
            .state('fareDelete', {
                parent: 'fares',
                url: '/fare/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/rates/fare/deleteFare.html',
                        controller: 'deleteFareController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'fareId': [function() {
                                return $stateParams.id
                            }],
                            'fare': ['fareService', function(fareService) {
                                return fareService.getFare($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('fares', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
